import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../tealium/data_layer';

// TODO: triggered from drupal brand-specific analytics.js
const defaultData: IDataLayer = {
  event_name: null, // <cart_overlay or cart_dropdown>
  event_category: null, // <cart_overlay or cart_dropdown>
  event_action: null, // <click or dismiss>
  event_label: null // <checkout or view_bag>
};

function trackCartDrawer(_: string, eventData: IDataLayer = {}) {
  if (eventData && eventData.cartDrawerCta) {
    eventData.event_name = eventData.cartDrawerCategory;
    eventData.event_category = eventData.cartDrawerCategory;
    eventData.event_action = eventData.cartDrawerAction;
    eventData.event_label = eventData.cartDrawerCta;
  }
  tealium.evtLink({ ...defaultData, ...eventData });
}

registerAnalyticsEventHandler('cartDrawer', trackCartDrawer);
